function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressVerificationBreadcrumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 10.0725C10.2923 10.0725 11.34 9.02483 11.34 7.73249C11.34 6.44014 10.2923 5.39249 8.99997 5.39249C7.70763 5.39249 6.65997 6.44014 6.65997 7.73249C6.65997 9.02483 7.70763 10.0725 8.99997 10.0725Z",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71503 6.3675C4.19253 -0.127498 13.815 -0.119998 15.285 6.375C16.1475 10.185 13.7775 13.41 11.7 15.405C10.1925 16.86 7.80753 16.86 6.29253 15.405C4.22253 13.41 1.85253 10.1775 2.71503 6.3675Z",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressVerificationBreadcrumb);
export default __webpack_public_path__ + "static/media/address-verification-breadcrumb.3e22802ae336f9ee185907953a77b029.svg";
export { ForwardRef as ReactComponent };